import styled from "styled-components";

export const AccountTitle = styled.div`
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  width: 90%;
  margin-top: 32px;
  position: relative;
`;

export const StyledTitle = styled.div`
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    color: #0F0F0F;
`

export const ButtonContainer = styled.div`
    display: flex;
    width: 15%;
    margin-top: 11px;
`